import { render, staticRenderFns } from "./CaseDelayedChart.vue?vue&type=template&id=f8839fc6&"
import script from "./CaseDelayedChart.vue?vue&type=script&lang=js&"
export * from "./CaseDelayedChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports